export enum KeyboardMode {
    ON = 'ON',
    OFF = 'OFF'
}
